import * as ReactService from "@intech/react-service";

class Version extends ReactService.BaseService {
  constructor() {
    super("Version");
  }

}

export const VersionService = new Version();
